// extracted by mini-css-extract-plugin
module.exports = {"root":"CookieBanner_root__G5RGz","link":"CookieBanner_link__HIcd9"};